module.exports = __webpack_public_path__ + "img/body-2-lg.c1398c58.png";